import { Radio, RadioChangeEvent } from 'antd';
import React, { memo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { INTEREST_CAPITAL_DESC,
  INTEREST_LATE_DESC,
  INTEREST_MED_PUBLIC_DESC,
  INTEREST_TRANSACTION_DESC } from '../../../services/calc/interestDesc';
import { useAppDispatch, useTypedSelector } from '../../../store';
import { interestTypeUpdated, INTEREST_AGREE, INTEREST_CAPITAL, INTEREST_LATE, INTEREST_MED_PUBLIC, INTEREST_TRANSACTION } from '../../../store/lawsuitOpts';
import { lsIncreaseStepDisabled } from '../../../store/lawsuitUI';
import { CardPlaceholder, CardRadio, CardRadioButton, GRID_LG } from '../../../styles';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import InfoRadio from '../../UI/InfoRadio';
import StepCard from '../StepCard/StepCard';
import StepOneInput from './StepOne/StepOneInput';

const TypeOfInterest = () => {

  const { width } = useWindowSize();

  const  typeOfInterest = useTypedSelector(state =>
    state.lawsuitOpts.typeOfInterest);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onPress = (event:RadioChangeEvent) => {
    dispatch(interestTypeUpdated(event.target.value));
    dispatch(lsIncreaseStepDisabled(false));
  };

  if (width < GRID_LG) {
    return (
      <StepCard title={t('interestType.title')} desc={t('interestType.desc')}>
        <Radio.Group
          onChange={onPress}
          value={typeOfInterest}
          style={{ width: '100%' }}
        >
          <Button2Lines
            value={INTEREST_TRANSACTION}
          >
            {t('interest.trans.long')}
          </Button2Lines>
          <CardRadioButton
            value={INTEREST_LATE}
          >
            {t('interest.late')}
          </CardRadioButton>
          <CardRadioButton value={INTEREST_CAPITAL}>
            {t('interest.capital')}
          </CardRadioButton>
          <Button3Lines
            value={INTEREST_MED_PUBLIC}
          >
            {t('interest.med.short')}
          </Button3Lines>
          <CardRadioButton value={INTEREST_AGREE}>
            {t('interest.agree')}
          </CardRadioButton>
        </Radio.Group>
        <StepOneInput />
        <CardPlaceholder />
      </StepCard>
    );
  }
  return (
    <StepCard title={t('interestType.title')} desc={t('interestType.desc')}>
      <Radio.Group
        onChange={onPress}
        value={typeOfInterest}
        style={{ width: '100%' }}
      >
        <CardRadio
          value={INTEREST_TRANSACTION}
        >
          <InfoRadio
            text={t('interest.trans.long')}
            tooltip={INTEREST_TRANSACTION_DESC.legalBasis}
          />
        </CardRadio>
        <CardRadio
          value={INTEREST_LATE}
        >
          <InfoRadio
            text={t('interest.late')}
            tooltip={INTEREST_LATE_DESC.legalBasis}
          />
        </CardRadio>
        <CardRadio value={INTEREST_CAPITAL}>
          <InfoRadio
            text={t('interest.capital')}
            tooltip={INTEREST_CAPITAL_DESC.legalBasis}
          />
        </CardRadio>
        <CardRadio
          value={INTEREST_MED_PUBLIC}
        >
          <InfoRadio
            text={width < GRID_LG ? t('interest.med.short') : t('interest.med.long')}
            tooltip={INTEREST_MED_PUBLIC_DESC.legalBasis}
          />
        </CardRadio>
        <CardRadio value={INTEREST_AGREE}>
          {t('interest.agree')}
        </CardRadio>
      </Radio.Group>
      <StepOneInput />
      <CardPlaceholder />
    </StepCard>
  );
};



export default memo(TypeOfInterest);


export const Button3Lines = styled(CardRadioButton)`
  	@media only screen and (max-width: 580px) {
     padding-top: 34px;
     padding-bottom: 34px;
	}
  	@media only screen and (max-width: 355px) {
     padding-top: 52px;
     padding-bottom: 52px;
	}
`;

export const Button2Lines = styled(CardRadioButton)`
  	@media only screen and (max-width: 520px) {
      padding-top: 34px;
     padding-bottom: 34px;
	}
`;